module.exports = __webpack_public_path__ + "img/51990825.a3506eff.png";